export default "__VITE_ASSET__c9d982fa__"